import {
	normalizeCountryToVisionKey,
	normalizeNationalityToVisionKey,
} from '../constants/visionCountryMap'

const HOME_TARGET_COUNTRIES = new Set([
	'uae',
	'saudi_arabia',
	'singapore',
	'malaysia',
	'japan',
	'vietnam',
	'indonesia',
])

const normalizeTier = tier =>
	String(tier || '')
		.trim()
		.toLowerCase()

const asScore = value => {
	const n = Number(value)
	return Number.isFinite(n) ? n : Number.NEGATIVE_INFINITY
}

const toCountryRow = (country, row) => ({
	country,
	tier: String(row?.tier || '').trim(),
	score: String(row?.score || '').trim(),
	policy: String(row?.policy || '').trim(),
	reason: String(row?.reason || '').trim(),
	_score: asScore(row?.score),
})

const tierWeight = tier => {
	const t = normalizeTier(tier)
	if (t === 'tier 1') return 1
	if (t === 'tier 2') return 2
	if (t === 'tier 3') return 3
	return 99
}

export const resolveHomeCountryKey = ({ profileBuilderData } = {}) => {
	const profile = profileBuilderData || {}
	const countryCandidates = [
		profile?.country,
		profile?.countryCode,
		profile?.country_code,
	]
	for (const candidate of countryCandidates) {
		const normalized = normalizeCountryToVisionKey(candidate)
		if (normalized) return normalized
	}

	const byNationality = normalizeNationalityToVisionKey(profile?.nationality)
	if (byNationality) return byNationality

	return null
}

const sortByTierAndScore = rows =>
	rows
		.slice()
		.sort((a, b) => {
			const tw = tierWeight(a.tier) - tierWeight(b.tier)
			if (tw !== 0) return tw
			return b._score - a._score
		})

export const getVisionCountriesForCareer = ({
	countriesByKey = {},
	homeCountryKey = null,
} = {}) => {
	if (!countriesByKey || typeof countriesByKey !== 'object') return []

	const sorted = sortByTierAndScore(
		Object.entries(countriesByKey).map(([country, row]) =>
			toCountryRow(country, row),
		),
	)

	const home = normalizeCountryToVisionKey(homeCountryKey)
	const homeRow = home ? countriesByKey[home] : null
	const homeTier = normalizeTier(homeRow?.tier)
	const homeAllowed =
		home &&
		home !== 'india' &&
		HOME_TARGET_COUNTRIES.has(home) &&
		(homeTier === 'tier 1' || homeTier === 'tier 2')

	if (!homeAllowed) {
		return sorted.map(({ _score, ...rest }) => rest)
	}

	const homeCountry = toCountryRow(home, homeRow)
	const rest = sorted.filter(item => item.country !== home)
	return [homeCountry, ...rest].map(({ _score, ...restRow }) => restRow)
}
